import type { QuickFilterDef } from "@/components/fw/data-table/types";
import type { StorefrontOrderDto } from "@/lib/storefront-api";

type OrderRow = StorefrontOrderDto;

export const orderQuickFilters: QuickFilterDef<OrderRow>[] = [];
